import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  message?: string;
}

export function ForbiddenState({ message }: Props) {
  return (
    <div className="flex h-screen items-center justify-center bg-background px-6">
      <div className="max-w-md text-center space-y-4">
        <div className="mx-auto w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-destructive" />
        </div>
        <h1 className="text-xl font-semibold text-foreground">
          У вас немає доступу
        </h1>
        <p className="text-sm text-muted-foreground">
          {message ??
            "Звернітьcя до адміністратора, якщо вважаєте, що це помилка."}
        </p>
        <div className="flex justify-center gap-2 pt-2">
          <Button variant="outline" asChild>
            <a href="/">На головну Espo</a>
          </Button>
          <Button asChild>
            <a href={import.meta.env.BASE_URL}>Спробувати ще раз</a>
          </Button>
        </div>
      </div>
    </div>
  );
}
